import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  ButtonGroup,
  Container,
  ListGroup,
  Row,
  ToggleButton,
} from 'react-bootstrap';
import styled from 'styled-components';
import { UilQrcodeScan } from '@iconscout/react-unicons';
import { useDispatch, useSelector } from 'react-redux';
import { addCheckin, setCurrentCheckin } from '../../actions/checkin';
import { Loader } from '../general/spinner';
import axios from 'axios';

const Logo = 'https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fassets%2Flogos%2Flogo2022.png?alt=media&token=cd5a4b18-8c96-4f88-a0d0-408a5cae621c';

const ScanDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 30px;
  > div svg {
    color: #00ad90;
  }
  > h1 {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 900;
    font-size: 22px;
    line-height: 33px;
    text-align: center;
    color: #00ad90;
  }
`;

const Qr = styled.div`
  padding: 20px;
  border-radius: 16px;
`;

const ConfirmButton = styled.button`
  width: 297px;
  height: 48px;
  background: #6fbea0;
  border: none;
  border-radius: 24px;
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #ffffff;
  :hover {
    background: #81d6b6;
  }
`;

export const Welcome = (props) => {
  const { currentCheckin } = useSelector((state) => state);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const confirm = async() => {
    await completeCheckinClientes(currentCheckin.solicitud?.driveThru);
    if (!props.payedNow) {
      if (currentCheckin) {
        const data = {
          referencia: 'KIOSCO-CLIP', // referencia: "Kiosco clip"
          total: currentCheckin.estudios.reduce(
            (n, { precioNeto }) => n + precioNeto,
            0
          ), // total a pagar
          age: currentCheckin.edad,
          folio: currentCheckin.drive.folio, // folio,
          birthday: currentCheckin.fnac, // No sé si es necesario
          branch: currentCheckin.sucursal.toString(), // Sucursal desde "-1" hasta "5"
          coupon: {
            comment: currentCheckin.drive.cupon + ' coment',
            name: currentCheckin.drive.cupon,
            total: '0',
          },
          datetime: currentCheckin.drive?.fechaYhora
            ? currentCheckin.drive?.fechaYhora
            : '03/05/2022 - 09:40', // Formato --> "DD/MM/YYYY - HH:mm"
          // El "datetime" yo lo paso a timestamp con una función específica de Firebase.
          gender: currentCheckin.genero,
          idS: currentCheckin.solicitud.id,
          id: currentCheckin.drive.id,
          invoice: false, // "Sí" | "No" o un Booleano y yo lo convierto
          paid: true,
          paidInKiosko: false,
          methodPayment: currentCheckin.drive.tipopago,
          patient: `${currentCheckin.nombre} ${currentCheckin.apellidos}`, // Nombre del paciente
          study: currentCheckin.estudios,
        };
        console.log(data);
        saveData(data);
      }
    }
  };

  const saveData = async (data) => {
    await setLoading(true);
    dispatch(addCheckin(data));
    await setLoading(false);
  };

  const completeCheckinClientes = async (driveThruID) => {
    try {
      const result = await axios.get(`https://clienteslabopat.com/set-checkin?id=${driveThruID}`);
      if (result?.ok) {
        console.log('RES: ', result.data);
      } else {
        console.log("Error al completar checkin");
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <ScanDiv>
      <h1>Bienvenido a Labopat</h1>
      <h5>
        Da clic en el boton "Confirmar asistencia" para terminar tu proceso
      </h5>
      <Qr id='qrdiv' onClick={() => console.log('Clicked')}>
        {/* <UilQrcodeScan size={200} /> */}
        <br />
        <br />
        <img src={Logo} alt='Labopat Logo' />
        <br />
        <br />
        <br />
        <br />
      </Qr>

      <div className='d-flex justify-content-center'>
        <ConfirmButton onClick={() => confirm()}>
          Confirmar asistencia
        </ConfirmButton>
      </div>
      <br />
      <br />
    </ScanDiv>
  );
};
